// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from "jquery"

// 设置Vue以静默模式运行，不显示任何警告
// Vue.config.silent = true;

import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// import 'lib-flexible'
import Print from 'vue-print-nb'
Vue.use(Print);

import '../static/iconfont/iconfont.css';// 引入样式

import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
Vue.use(UmyUi);

import plTable from 'pl-table'
import 'pl-table/themes/index.css'
import 'pl-table/themes/plTableStyle.css'
Vue.use(plTable);

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/directives.js'// element弹窗拖拽
Vue.use(ElementUI);

import { Message } from 'element-ui'//消息提示插件
Vue.prototype.$Message = Message

Vue.prototype.$browser={
  versions:function(){
    var u = navigator.userAgent, app = navigator.appVersion;
    var agent = navigator.userAgent.toLowerCase();
    var isWin32 = agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0;
    var isWin64 = agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0;
    return {
      isWin32: isWin32,
      isWin64: isWin64,
      isWindow: isWin64 || isWin32 ||  agent.indexOf("windows") >= 0,
      isMac: /macintosh|mac os x/i.test(u),
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  }(),
  language:(navigator.browserLanguage || navigator.language).toLowerCase()
}
// 查看图片
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		"inline": true, "button": true, "navbar": true, "title": true, "toolbar": true,
		"tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true,
		"transition": true, "fullscreen": true, "keyboard": true, "url": "data-source"
	}
});

import api from './axios/api.js'
import http from './axios/http.js'
//定义全局变量
Vue.prototype.$api = api
Vue.prototype.$http = http

Vue.config.productionTip = false

// el-select触底懒加载
Vue.directive('el-select-loadmore', {
  bind(el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (condition) {
        binding.value();
      }
    })
  }
})

// 通过插件的形式挂载
import Vuex from 'vuex'
import store from './vuex/store'
Vue.use(Vuex)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
//	axios,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js